module.exports = __webpack_public_path__ + "img/red-cross.cdd38bd2.svg";